// Shared explainer copy for the context UI surfaces (chip + panel). Kept in
// one module so the wording cannot drift between the two render sites.

/** Chip tooltip — one line; the Tooltip renders whitespace-nowrap. */
export const CONTEXT_CHIP_TOOLTIP =
  'Window is what the next turn sends — it resets each turn. Memory is retained and searchable; nothing is lost.';

/** Panel session-line tooltip — one line; the Tooltip renders whitespace-nowrap. */
export const CONTEXT_SESSION_TOOLTIP =
  'Retained: tokens kept in the context store, all retrievable. Spent: cumulative provider usage across every agent.';
